export default __webpack_public_path__ + "static/media/displayer_bullground.03a7250d.png";